import VoteContainer from './VoteContainer';

export default VoteContainer;
